export default {
  controllerAttribute: 'data-jc-controller',
  actionAttribute: 'data-jc-action',
  targetAttribute: 'data-jc-target'
};